import { Box } from '@mui/material';
import PublicLayout from '@/layouts/PublicLayout';
import HeroSection from '@/components/landing/hero/HeroSection';
import FeatureSection from '@/components/landing/features/FeatureSection';
import TestimonialsSection from '@/components/landing/TestimonialsSection';
import SurveyCTASection from '@/components/landing/SurveyCTASection';

export default function LandingPage() {
  return (
    <PublicLayout hasDarkHero={true}>
      {/* Hero Section */}
      <HeroSection />

      {/* Features Section */}
      <FeatureSection />
{/* Survey CTA Section */}
<Box 
        component="section"
        sx={{ 
          position: 'relative',
          pt: { xs: 4, md: 6 },
          pb: { xs: 8, md: 12 },
          background: 'linear-gradient(180deg, #1a1133 0%, #1a1133 8%, #231640 12%, #2a1b4d 16%, #31205a 20%, #382567 24%, #3f2a74 28%, #462f81 32%, #4d348e 36%, #54399b 40%, #5b3ea8 44%, #6243b5 48%, #6B46C1 52%, #6548c0 60%, #5f4abf 70%, #4C51BF 100%)',
          width: '100%'
        }}
      >
        <SurveyCTASection />
      </Box>
      {/* Testimonials Section */}
      <Box 
        component="section"
        sx={{ 
          py: { xs: 8, md: 12 },
          bgcolor: 'white',
          width: '100%',
        }}
      >
        <TestimonialsSection />
      </Box>

      

      {/* Temporarily removed Partners Section */}
      {/* <Box 
        component="section"
        sx={{ 
          py: { xs: 8, md: 12 },
          bgcolor: 'grey.50',
          width: '100%',
        }}
      >
        <PartnersSection />
      </Box> */}
    </PublicLayout>
  );
}